// Sentry's server-side N+1 detector mistakes normal map asset fan-out for API calls.
// Filter after completion so failed/unfinished requests remain available for diagnosis.
export const ignoreSuccessfulMapAssetSpans = [
  {
    op: /^http\.client$/,
    name: /^GET https:\/\/api\.mapbox\.com\/(?:styles\/v1|fonts\/v1|v4)\//,
    attributes: { 'http.response.status_code': 200 },
  },
]
